import React from "react";
import MaterialIcon from "./MaterialIcon.jsx";


export default function DragHandle({ className, ...props }) {
	return (
		<span
			className={`${className} drag_handle`}
			{...props}
		>
			<MaterialIcon>drag_indicator</MaterialIcon>
		</span>
	);
}